declare global {
    interface DocumentEventMap {
        'toggle_element': CustomEvent<{ $element: HTMLElement, isVisible: boolean }>;
    }
}

/**
 * Toggle an element on click on other
 * 
 * Usage :
 * <button data-toggle="#element-to-toggle">Toggle element</button>
 * <div id="element-to-toggle">I'm hidden</div>
 * 
 * You can toggle many element by typing : data-toggle="{{ ['#element-1', '#element-2', '.my-elements']|json_encode }}"
 */
export default function initToggler() : void {
    const $togglers = document.querySelectorAll<HTMLElement>('.js-toggler');

    $togglers.forEach($toggler => {
        const $targets: HTMLElement[] = [];

        try {
            JSON.parse($toggler.dataset.toggle as string).forEach((target: string) => {
                document.querySelectorAll<HTMLElement>(target).forEach($target => {
                    $targets.push($target);
                });
            });
        } catch (err) {
            document.querySelectorAll<HTMLElement>($toggler.dataset.toggle as string).forEach($target => {
                $targets.push($target);
            });
        }

        $toggler.addEventListener('click', () => {
            $targets.forEach($target => {
                if ($target) {
                    $target.classList.toggle('hidden');
        
                    document.dispatchEvent(new CustomEvent('toggle_element', {
                        detail: {
                            $element: $target,
                            isVisible: !$target.classList.contains('hidden'),
                        },
                    }));
                }
            });
        });
    });
}
